/* Store switch (Kazakhstan ⇄ India): popup + header menu + keeps the same page when switching */
(function () {
  // this page's address without the language part (/ru/products/x → /products/x)
  function samePath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var p = window.location.pathname;
    if (root !== '/') {
      if (p.indexOf(root) === 0) p = '/' + p.slice(root.length);
      else if (p + '/' === root) p = '/';
    }
    return p;
  }

  // every switch link opens the same page in the other store, and tells it "I chose this store"
  document.querySelectorAll('[data-store-link]').forEach(function (link) {
    link.href = link.getAttribute('data-store-link').replace(/\/+$/, '') + samePath() + '?store_chosen=1';
  });

  // "I chose this store myself" – remembered until the browser is closed (cookie with no end date)
  var CHOSEN = 'chits_store_chosen';
  function hasChosen() { return document.cookie.split('; ').indexOf(CHOSEN + '=1') !== -1; }
  function setChosen() { document.cookie = CHOSEN + '=1; path=/; SameSite=Lax'; }

  var params = new URLSearchParams(window.location.search);
  function cleanUrl() {
    var q = params.toString();
    try { history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash); } catch (e) {}
  }
  if (params.get('store_chosen') === '1') {
    setChosen();
    params.delete('store_chosen');
    cleanUrl();
  }

  // header pill menu
  document.querySelectorAll('[data-rs-pill]').forEach(function (pill) {
    var btn = pill.querySelector('.rs-pill__btn');
    var menu = pill.querySelector('.rs-menu');
    function setOpen(open) {
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(menu.hidden);
    });
    pill.querySelectorAll('[data-rs-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); setOpen(false); });
    });
    document.addEventListener('click', function (e) { if (!pill.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  });

  // popup / automatic redirect
  var box = document.getElementById('StoreSwitch');
  if (!box) return;
  var target = box.getAttribute('data-country'); // country of the OTHER store
  var otherUrl = (box.getAttribute('data-other-url') || '').replace(/\/+$/, '');
  var auto = box.getAttribute('data-auto') === 'true';
  var notFound = box.getAttribute('data-notfound') === '1';
  var bar = document.getElementById('StoreRedirectBar');
  var storageKey = 'chitsStoreSwitchHiddenUntil';
  var testCountry = (params.get('store_test') || '').toUpperCase();

  // just arrived here from an automatic redirect → show the bar, never bounce back
  if (params.get('chits_redirected') === '1') {
    if (notFound) {
      // that page doesn't exist in this store → open the homepage instead
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.replace(root + '?chits_redirected=1');
      return;
    }
    params.delete('chits_redirected');
    cleanUrl();
    if (bar) {
      document.body.insertBefore(bar, document.body.firstChild);
      bar.hidden = false;
      bar.querySelector('[data-srb-close]').addEventListener('click', function () { bar.hidden = true; });
    }
    return;
  }

  function show() {
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-visible'); });
  }
  function stay() {
    box.classList.remove('is-visible');
    setTimeout(function () { box.hidden = true; }, 350);
    try { localStorage.setItem(storageKey, String(Date.now() + 24 * 60 * 60 * 1000)); } catch (e) {} // 1 day
  }
  box.querySelectorAll('[data-ss-stay]').forEach(function (b) { b.addEventListener('click', stay); });

  function goOther() {
    var q = new URLSearchParams(window.location.search);
    q.delete('store_test');
    q.set('chits_redirected', '1');
    window.location.replace(otherUrl + samePath() + '?' + q.toString());
  }

  // picked this store themselves (store switcher) → show the popup instead of redirecting
  var redirect = auto && !hasChosen();

  function decide(country) {
    if (country !== target) return;
    if (redirect) goOther();
    else setTimeout(show, testCountry ? 800 : 1500);
  }

  if (testCountry) {
    decide(testCountry);
    return;
  }
  if (/bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent)) return; // never redirect search engines
  if (!redirect) {
    // popup: hidden for 1 day after "Stay here"
    try { if (Number(localStorage.getItem(storageKey) || 0) > Date.now()) return; } catch (e) {}
  }

  // backup guess from the device time zone, used if Shopify's location check gives no answer
  function countryFromTimeZone() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (/^Asia\/(Kolkata|Calcutta)$/.test(tz)) return 'IN';
      if (/^Asia\/(Almaty|Qyzylorda|Aqtobe|Aqtau|Atyrau|Oral|Qostanay)$/.test(tz)) return 'KZ';
    } catch (e) {}
    return '';
  }

  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var c = data && data.detected_values && data.detected_values.country;
      return (c && c.handle) || countryFromTimeZone();
    })
    .catch(countryFromTimeZone)
    .then(decide);
})();